import React, { useState, useEffect } from "react";
import { Text } from "src/components/ui/Text";
import { BaseButton } from "src/components/ui/baseButton";
import { FileDownloadIcon } from "../icons";
import { useDempStore } from "src/context/stores";
import { downloadCSVCompanyTHP } from "src/api/widgets";

const ReportFoodSchool = () => {
  const [plantId] = useDempStore((state) => [state.plantId]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

  useEffect(() => {
    const currentMonth = new Date().toISOString().slice(0, 7);
    setSelectedMonth(currentMonth);
    updateDateRange(currentMonth);
  }, []);

  const updateDateRange = (month) => {
    const startDate = new Date(`${month}-01`); 
    const nextMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      1
    );
    const endDate = new Date(nextMonth - 1);

    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);
    setDateRange({ startDate: formattedStartDate, endDate: formattedEndDate });
  };

  const handleDownload = async () => {
    const dataRequest = {
      plant_id: plantId,
      start_date: dateRange?.startDate, 
      stop_date: dateRange?.endDate,
    };


    try {
      const { data, error } = await downloadCSVCompanyTHP(dataRequest);

      
      if (data) {
        const url = data?.report_url;
        const link = document.createElement("a");
        link.id = url;
        link.href = url;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }


    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download the report, please try again...");
    }

  };

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setSelectedMonth(newMonth);
    updateDateRange(newMonth);
  };

  return (
    <div
      className={`w-full h-[calc(100vh-7.125rem)] py-5 pl-6 pr-5 flex flex-col gap-4`}
    >
      <div className="flex flex-col w-full h-full gap-4 p-4 bg-white rounded-lg shadow-content-box">
        <div className="flex flex-col gap-2">
          <Text variant="bold-20">Report Food School</Text>
          <Text variant="normal-14" className="text-secondary">
            Select a month to download the report for the food school.
          </Text>
        </div>

        <div className="flex gap-4 items-center justify-start">
          <div
            className="relative w-64"
          >
            <label
              className="text-xs text-gray-700 absolute z-10 top-1 left-3 px-1"
            >
              Select Month and Year
            </label>
            <input
              id="month-selector"
              type="month"
              name="start"
              min="2018-03"
              value={selectedMonth}
              onChange={handleMonthChange}
              className="w-full border border-gray-300 rounded-md pt-6 pb-2 pl-3 pr-10 text-teal-600 font-semibold focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <BaseButton
              variant="primary"
              size="normal"
              onClick={handleDownload}
            >
              <div className="flex gap-1 items-center">
                <FileDownloadIcon />
                <Text variant="semi-12">Download report</Text>
              </div>
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportFoodSchool;
